<!-- 支付成功页面 -->
<template>
	<div class="home">
        <div v-if="orderDetail.type == 0">
            <div style="height: 200px;"></div>
            <van-button @click="$router.push('/OrderDetail/'+sessionStorage.actOrderId)" class="btn" block>{{$t('OrderDetail.view')}}</van-button>
        </div>
        <div v-if="orderDetail.type == 2 && orderDetail.status!=2">
            <div style="height: 200px;"></div>
            <van-button v-if="orderDetail.status==2" @click="$router.push('/TakeOrderDetail/'+orderDetail.id)" class="btn" block>{{$t('OrderDetail.checkOrder')}}</van-button>
    		<van-button v-else @click="continueOrder()" class="btn" block>{{$t('OrderDetail.newOrder')}}</van-button>
        </div>
        <van-loading size="50" type="spinner" v-show="isLoading"/>
	</div>
</template>

<script>
export default {
    data () {
        return {
        	orderDetail:{},
            transactionId: '',
            orderId: '',
            orderLineType: '',
            isLoading: true,
        };
    },
    mounted(){
    	this.transactionId = this.$route.query.transactionId;
    	this.orderId = this.$route.query.orderId;
        this.confirmPay();
    },
    methods: {
        // 确认支付
    	confirmPay(){
            if(this.transactionId && this.orderId){
                this.$axios({
                    method: 'get',
                    url: this.$build+'/api/line-pay/confirm',
                    params:{
                        transaction: this.transactionId,
                        order: this.orderId,
                    }
                }).then(res => {
                    console.log(res);
                    if(res.data.status == 200){
                        var vm = this;
                        // 获取订单详情
                        setTimeout(()=>{
                            vm.getOrderDetail();
                        },400)
                    }else{
                        this.continueOrder();
                    }
                }).catch(err => {
                    this.$toast({
                        type:'fail',
                        message:this.$t('common.message'),
                    });
                });
            }
        },
        // 获取订单详情
        getOrderDetail(){
            this.$axios({
                method: 'POST',
                url: this.$build+'/api/order/search',
                data:{
                    order:this.orderId
                }
            }).then(res => {
                if(res.data.status==200){
                    console.log(res)
                    this.orderDetail=res.data.data;
                    sessionStorage.setItem('code',this.orderDetail.code);
                    localStorage.setItem('successCode',this.orderDetail.code);
                    localStorage.setItem('takeOrderId',this.orderDetail.id);
                    sessionStorage.setItem('actOrderId',this.orderDetail.id);
                    localStorage.setItem('takeOrderNo',this.orderDetail.order);
                    if(this.orderDetail.place){
                        sessionStorage.setItem('storeId',this.orderDetail.place.store_id);
                        sessionStorage.setItem('placeId',this.orderDetail.place.id);
                        sessionStorage.setItem('type','');
                    }
                    if(this.orderDetail.order_address){
                        sessionStorage.setItem('storeId',this.orderDetail.order_address.store_id);
                    }

                    if(this.orderDetail.status == 2){
                        var vm = this;
                        // 跳转到订单页面
                        setTimeout(()=>{
                            localStorage.setItem('isPay',true);
                            if(vm.orderDetail.type == 0){
                                vm.$router.push('/OrderDetail/'+vm.orderDetail.id);
                            }else if(vm.orderDetail.type == 2){
                                vm.$router.push('/TakeOrderDetail/'+vm.orderDetail.id);
                            }
                        },500)
                    }else{
                        localStorage.setItem('isPay',false);
                    }
                }else{
                    for (var item in res.data.error) {
                        this.$toast({
                            type:'fail',
                            message:res.data.error[item],
                        });
                    }
                }
                this.isLoading = false;
            }).catch(err => {
                this.$toast({
                    type:'fail',
                    message:this.$t('common.message'),
                });
            });
        },
        // 获取订单详情
        // getOrderDetail(){
        //     if(this.orderLineType == 'insite'){
        //         this.$axios({
        //             method: 'PUT',
        //             headers: {
        //                 'type':sessionStorage.type,
        //                 'code':sessionStorage.code,
        //                 'placeid':sessionStorage.placeId,
        //             },
        //             url: this.$build+'/api/order/'+sessionStorage.actOrderId+'/customerIndex',
        //         }).then(res => {
        //             if(res.data.status==200){
        //                 this.orderDetail=res.data.data;
        //                 if(this.orderDetail.status == 2){
        //                     var vm = this;
        //                     // 跳转到订单页面
        //                     setTimeout(()=>{
        //                         localStorage.setItem('isPay',true);
        //                         vm.$router.push('/OrderDetail/'+sessionStorage.actOrderId);
        //                     },500)
        //                 }else{
        //                     localStorage.setItem('isPay',false);
        //                 }
        //                 console.log(this.orderDetail.status);
        //             }else{
        //                 for (var item in res.data.error) {
        //                     this.$toast({
        //                         type:'fail',
        //                         message:res.data.error[item],
        //                     });
        //                 }
        //             }
        //         }).catch(err => {
        //             this.$toast({
        //                 type:'fail',
        //                 message:this.$t('common.message'),
        //             });
        //         });
        //     }else{
        //         this.$axios({
        //             method: 'PUT',
        //             url: this.$build+'/api/order/'+localStorage.takeOrderId+'/takeIndex',
        //         }).then(res => {
        //             if(res.data.status==200){
        //                 console.log(res)
        //                 this.orderDetail=res.data.data;
        //                 if(this.orderDetail.status == 2){
        //                     var vm = this;
        //                     // 跳转到订单页面
        //                     setTimeout(()=>{
        //                         localStorage.setItem('isPay',true);
        //                         vm.$router.push('/TakeOrderDetail/'+localStorage.takeOrderId);
        //                     },500)
        //                 }else{
        //                     localStorage.setItem('isPay',false);
        //                 }
        //             }else{
        //                 for (var item in res.data.error) {
        //                     this.$toast({
        //                         type:'fail',
        //                         message:res.data.error[item],
        //                     });
        //                 }
        //             }
        //         }).catch(err => {
        //             this.$toast({
        //                 type:'fail',
        //                 message:this.$t('common.message'),
        //             });
        //             this.continueOrder();
        //         });
        //     }
        // },
        continueOrder(){
            this.$axios({
                method:'get',
                url:this.$build+'/api/shopcart/create',
            }).then(res=>{
                console.log(res)
                this.isLoading = false;
                if(res.data.status==200){
                    localStorage.setItem('onlyCode',res.data.code)
                    var vm = this;
                    // 跳转到菜品页面
                    setTimeout(()=>{
                        vm.$router.push('/TakeDishes')
                    },500)
                }else{
                    for (var item in res.data.error) {
                        this.$toast({
                            type:'fail',
                            message:res.data.error[item],
                        });
                    }
                }
            }).catch(err => {
                this.$toast({
                    type:'fail',
                    message:this.$t('common.message'),
                });
            });
        },
    }
}

</script>
<style scoped>
    .home{
        width: 100%;
        height: 100vh;
        background-color: #fff;position: relative;
    }
	.btn{
		background: #2f75f4;
		color: #fff;
		margin:10px auto;
		width: 50%;
		border-radius: 10px;
	}
    /deep/ .van-loading {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        -webkit-transform: translate(-50%,-50%);
    }
</style>


// WEBPACK FOOTER //
// src/takeAway/PaySuccess.vue